module.exports = __webpack_public_path__ + "assets/img/条形码.8b14d95f.svg";